import { T_ApiResponse } from "../../globalTypes/GlobalTypes";
import { CSApiService } from "../../redux-store/CSApiService";
import {
  Api_CheckMobilePermission,
  Api_CreateMpin,
  Api_FetchConsent,
  Api_GenerateInternalToken,
  Api_GenerateOtp,
  Api_GenerateToken,
  Api_GetCustomerLobDetails,
  Api_GetCustomerLobDetailsV2,
  Api_Mpin_Exist,
  Api_Mpin_Forget,
  Api_Mpin_Validate,
  Api_Register_Biometric,
  Api_SaveCrossSellContent,
  Api_ValidateOtp,
} from "../../utils/ApiEndpoints";
import {
  T_CheckConsent,
  T_CheckPermission,
  T_CreateMpinPay,
  T_CreateMpinRes,
  T_GenerateOtpPay,
  T_GenerateOtpRes,
  T_GenerateTokenRes,
  T_GetCustomerLobDetailsPay,
  T_GetCustomerLobDetailsRes,
  T_InternalTokenRes,
  T_MpinExisRequest,
  T_MpinExistorNotRes,
  T_RegisterBiometric,
  T_RegisterBiometricRes,
  T_SaveCrossSellConsent_Request,
  T_SaveCrossSellConsent_Response,
  T_ValidateOtpPay,
  T_ValidateOtpRes,
} from "./Login_Types";
export const loginRtk = CSApiService.injectEndpoints({
  overrideExisting: "throw",
  endpoints: (builder) => ({
    generateToken: builder.query<T_ApiResponse<T_GenerateTokenRes>, void>({
      query: () => ({ url: Api_GenerateToken }),
    }),
    getInternalToken: builder.query<T_ApiResponse<T_InternalTokenRes>, string>({
      query: (csUserId) => ({
        url: Api_GenerateInternalToken,
        headers: {
          csUserId: csUserId,
        },
      }),
    }),
    generateOtp: builder.query<
      T_ApiResponse<T_GenerateOtpRes>,
      T_GenerateOtpPay
    >({
      query: (payload) => ({
        url: Api_GenerateOtp,
        method: "POST",
        body: payload,
      }),
    }),
    validateOtp: builder.query<
      T_ApiResponse<T_ValidateOtpRes>,
      T_ValidateOtpPay
    >({
      query: (payload) => ({
        url: Api_ValidateOtp,
        method: "POST",
        body: payload,
      }),
    }),
    getCustomerLobDetails: builder.query<
      T_ApiResponse<T_GetCustomerLobDetailsRes>,
      T_GetCustomerLobDetailsPay
    >({
      providesTags: ["CUSTOMER_LOB_DETAILS"],
      query: (payload) => ({
        url: Api_GetCustomerLobDetails,
        method: "POST",
        body: payload,
      }),
    }),
    getCustomerLobDetailsV2: builder.query<
      T_ApiResponse<T_GetCustomerLobDetailsRes>,
      T_GetCustomerLobDetailsPay
    >({
      providesTags: ["CUSTOMER_LOB_DETAILS"],
      query: (payload) => ({
        url: Api_GetCustomerLobDetailsV2,
        method: "POST",
        body: payload,
      }),
    }),
    createMpin: builder.query<T_ApiResponse<T_CreateMpinRes>, T_CreateMpinPay>({
      query: (payload) => ({
        url: Api_CreateMpin,
        method: "POST",
        body: payload,
      }),
    }),

    checkIfUserConsentRequired: builder.query<
      T_ApiResponse<T_CheckConsent>,
      string
    >({
      query: (mobileNumber) => ({
        url: Api_FetchConsent,
        method: "POST",
        body: { mobileNumber },
      }),
    }),
    checkIfPhonePermissionRequired: builder.query<
      T_ApiResponse<T_CheckPermission>,
      string
    >({
      query: (mobile) => ({
        url: Api_CheckMobilePermission,
        method: "POST",
        body: { mobile },
      }),
    }),
    registerBiometric: builder.query<
      T_ApiResponse<T_RegisterBiometricRes>,
      T_RegisterBiometric
    >({
      query: (payload) => ({
        url: Api_Register_Biometric,
        method: "POST",
        body: payload,
      }),
    }),

    mPinExist: builder.query<
      T_ApiResponse<T_MpinExistorNotRes>,
      T_MpinExisRequest
    >({
      query: (payload) => ({
        url: Api_Mpin_Exist,
        method: "POST",
        body: payload,
      }),
    }),

    validateMpinData: builder.query<
      T_ApiResponse<T_CreateMpinRes>,
      T_CreateMpinPay
    >({
      query: (payload) => ({
        url: Api_Mpin_Validate,
        method: "POST",
        body: payload,
      }),
    }),

    forgetMpin: builder.query<T_ApiResponse<T_CreateMpinRes>, T_CreateMpinPay>({
      query: (payload) => ({
        url: Api_Mpin_Forget,
        method: "POST",
        body: payload,
      }),
    }),
    saveCrossSellConsent: builder.query<
      T_ApiResponse<T_SaveCrossSellConsent_Response>,
      T_SaveCrossSellConsent_Request
    >({
      query: (payload) => ({
        url: Api_SaveCrossSellContent,
        method: "POST",
        body: payload,
      }),
    }),
  }),
});

export const {
  useLazyGenerateOtpQuery,
  useLazyValidateOtpQuery,
  useLazyGenerateTokenQuery,
  useGenerateTokenQuery,
  useLazyGetCustomerLobDetailsQuery,
  useLazyGetCustomerLobDetailsV2Query,
  useLazyCreateMpinQuery,
  useLazyGetInternalTokenQuery,
  useLazyCheckIfUserConsentRequiredQuery,
  useLazyCheckIfPhonePermissionRequiredQuery,
  useLazyRegisterBiometricQuery,
  useLazyMPinExistQuery,
  useLazyValidateMpinDataQuery,
  useLazyForgetMpinQuery,
  useLazySaveCrossSellConsentQuery,
} = loginRtk;
